import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Credit2 = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M22.071 3H1.93A1.929 1.929 0 0 0 0 4.929V19.07C0 20.137.863 21 1.929 21H22.07A1.929 1.929 0 0 0 24 19.071V4.93A1.929 1.929 0 0 0 22.071 3zM2 9h20v1H2V9zm0-4h20v2H2V5zm0 14v-7h20v7H2z" />
    <path d="M12 15H5a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zM19 15h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2z" />
  </SvgIcon>
);

export default Credit2;
